/**
 * Runtime configuration shared by the page and the Turso leader worker bundle.
 *
 * EAS Hosting applies the app's COOP/COEP headers to route responses, but not to
 * static assets. A cross-origin-isolated document therefore cannot load the
 * public leader-worker or sync-wasm files as module scripts: Chromium rejects
 * them with `ERR_BLOCKED_BY_RESPONSE`. The page fetches those files as ordinary
 * same-origin data, turns them into Blob module URLs, and injects the two values
 * below before the leader bundle evaluates.
 */

export const TURSO_LEADER_RESOURCE_ID_GLOBAL_KEY = "__HANIVERSE_TURSO_LEADER_RESOURCE_ID__";

export const TURSO_SYNC_WASM_MODULE_URL_GLOBAL_KEY = "__HANIVERSE_TURSO_SYNC_WASM_MODULE_URL__";

const LEADER_WORKER_PATH_SEGMENTS = ["", "turso-leader-worker", "main.mjs"];
const SYNC_WASM_PATH_SEGMENTS = ["", "turso-sync-wasm", "main.es.js"];

function getPublicAssetUrl(pathSegments: readonly string[]): string {
  const path = pathSegments.join("/");
  return typeof location === "undefined" ? path : new URL(path, location.origin).href;
}

export function getTursoLeaderWorkerAssetUrl(): string {
  return getPublicAssetUrl(LEADER_WORKER_PATH_SEGMENTS);
}

export function getTursoSyncWasmAssetUrl(): string {
  return getPublicAssetUrl(SYNC_WASM_PATH_SEGMENTS);
}

export function getInjectedTursoLeaderResourceId(): unknown {
  return Reflect.get(globalThis, TURSO_LEADER_RESOURCE_ID_GLOBAL_KEY);
}

export function getInjectedTursoSyncWasmModuleUrl(): string | null {
  const value: unknown = Reflect.get(globalThis, TURSO_SYNC_WASM_MODULE_URL_GLOBAL_KEY);
  return typeof value === "string" && value !== "" ? value : null;
}
